import {MyNewsTypeVo} from '../../common/shared/api/nicolas/vo/enums/MyNewsTypeVo.enum';
import {MyNewsType} from '../generated/types';

export function createMyNewsType(myNewsTypeVo: MyNewsTypeVo): MyNewsType {
  return mapper[myNewsTypeVo];
}

const mapper: {[key in MyNewsTypeVo]: MyNewsType} = {
  [MyNewsTypeVo.Normal]: MyNewsType.Normal,
  [MyNewsTypeVo.Series]: MyNewsType.Series,
  [MyNewsTypeVo.UserRelated]: MyNewsType.UserRelated,
};
